module.exports = require("@seddi/wa-garments-geometry");